import type { ReactNode } from 'react';

export type TagTone = 'neutral' | 'confirmed' | 'pending' | 'refunded' | 'public' | 'strong';

export interface TagProps {
  children: ReactNode;
  tone?: TagTone;
}

const TONE: Record<TagTone, string | null> = {
  neutral: null,
  confirmed: 'tagConfirmed',
  pending: 'tagPending',
  refunded: 'tagRefunded',
  public: 'tagPublic',
  strong: 'tagStrong',
};

export function Tag({ children, tone = 'neutral' }: TagProps) {
  return <span className={['tag', TONE[tone]].filter(Boolean).join(' ')}>{children}</span>;
}
